<template>
    <v-container fluid style="background: #eaedf1">
        <v-sheet class="pa-3">
            <v-progress-linear
                color="secondary"
                :value="progress"
                height="20"
                stream
                :buffer-value="progressBuffer"
            ></v-progress-linear>
            <v-window v-model="step">
                <v-window-item :value="1">
                    <Step1 @next="next()" class="mx-auto mt-3 new-campaign-card"/>
                </v-window-item>

                <v-window-item :value="2">
                    <Step2 @next="next()" @prev="prev()" class="mx-auto mt-3 new-campaign-card"/>
                </v-window-item>

                <v-window-item :value="3">
                    <Step3 @next="next()" @prev="prev()" class="mx-auto mt-3 new-campaign-card"/>
                </v-window-item>

                <v-window-item :value="4">
                    <Step4 @next="next()" @prev="prev()" class="mx-auto mt-3 new-campaign-card"/>
                </v-window-item>

                <v-window-item :value="5">
                    <Step5 @next="next()" @prev="prev()" class="mx-auto mt-3 new-campaign-card"/>
                </v-window-item>

                <v-window-item :value="6">
                    <Step6 @next="next()" @prev="prev()" class="mx-auto mt-3 new-campaign-card"/>
                </v-window-item>

                <v-window-item :value="7" class="mx-auto mt-3 new-campaign-card">
                    <Step7 @prev="prev()" />
                </v-window-item>
            </v-window>
        </v-sheet>
    </v-container>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import Step1 from "@/components/loyaltyPanel/newCampaign/Step1Category"
import Step2 from "@/components/loyaltyPanel/newCampaign/Step2Type"
import Step3 from "@/components/loyaltyPanel/newCampaign/Step3Conditions"
import Step4 from "@/components/loyaltyPanel/newCampaign/Step4Characteristics"
import Step5 from "@/components/loyaltyPanel/newCampaign/Step5RewardDraw"
import Step6 from "@/components/loyaltyPanel/newCampaign/Step6Notifications"
import Step7 from "@/components/loyaltyPanel/newCampaign/Step7Title"
import newCampaign from "../../../utils/translations/loyaltyPanel/campaigns/newCampaign";

export default {
    name: "NewCampaign.vue",

    components: {
        Step1,
        Step2,
        Step3,
        Step4,
        Step5,
        Step6,
        Step7
    },

    data: () => ({
        // maxStep:1
    }),

    computed: {
        ...mapState("loyaltyPanel/campaigns/newCampaign", [
            "newCampaign",
            "campaignTypes", 
            "step",
            "maxStep"
        ]),

        progress() {
           return this.getProgress(this.step)
        },

        progressBuffer() {
           return this.getProgress(this.maxStep)
        },

        progressColor() {
            let color;

            switch (this.progress) {
                case 16.6:
                    color = "red";
                    break;
                case 33.2:
                    color = "#fced62";
                    break;
                case 49.8:
                    color = "#ffca4f";
                    break;
                case 66.4:
                    color = "#ffac40";
                    break;
                case 83.2:
                    color = "orange";
                    break;
                case 100:
                    color = "green";
            }

            return color;
        }
    },

    methods: {
        
        ...mapActions("loyaltyPanel/campaigns/newCampaign", [
            "getCampaignTypes"
        ]),
        ...mapMutations("loyaltyPanel/campaigns/newCampaign",["setCanGoToNextStep", "setStep", "setNewCampaign", "setMaxStep"]),

        next(val = null){
            this.setStep( val ||  this.step +1)
            if (this.step > this.maxStep) {
                this.setMaxStep(this.maxStep+1)
            }
        },

        prev(){
            this.setStep(this.step - 1)
        },
        getProgress(val){
            let lastStep = 6
            // switch (val) {
            //     case 1:
            //         return 0;
            //     case 2:
            //         return 17;
            //     case 3:
            //         return 33;
            //     case 4:
            //         return 50;
            //     case 5:
            //         return 67;
            //     case 6:
            //         return 84;
            // }
            return parseInt((val-1) * (100/lastStep))
        }
    },
    mounted() {
        this.getCampaignTypes()
        if (this.maxStep === 1 ) {
            this.setNewCampaign({})
        }
    },
    watch: {
        maxStep(val){
            this.setCanGoToNextStep(false)
        }
    }
};
</script>

<style scoped>
.border-grey {
    border: 2px solid grey;
}

.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
<style>
.new-campaign-card{
    border: none !important;
    max-width: 1200px;
}
</style>
